import { Capacitor } from '@capacitor/core';

const ALL_LOGIN_ROLES = ['admin', 'head', 'teacher'];

function parseEnvBool(name) {
  const value = process.env[name];
  if (value === 'true') return true;
  if (value === 'false') return false;
  return undefined;
}

/** Whether the Admin tab and login flow are available in this build. */
export function isAdminLoginAllowed() {
  const forceShow = parseEnvBool('REACT_APP_SHOW_ADMIN_LOGIN');
  if (forceShow === true) return true;

  const forceHide = parseEnvBool('REACT_APP_HIDE_ADMIN_LOGIN');
  if (forceHide === true) return false;

  if (Capacitor.isNativePlatform()) return false;

  return true;
}

export function getLoginRoleOptions(labels) {
  return ALL_LOGIN_ROLES.filter((role) => role !== 'admin' || isAdminLoginAllowed()).map(
    (role) => ({
      value: role,
      label: labels[role],
    })
  );
}

export function assertLoginRoleAllowed(role) {
  if (role === 'admin' && !isAdminLoginAllowed()) {
    return false;
  }
  return ALL_LOGIN_ROLES.includes(role);
}
